
    <div class="calendar-wrapper">
      <div class="menu">
        <p class="month-text">{{ currentMonth }}</p>
        <div class="buttons">
          <svg
            width="34"
            height="30"
            viewBox="0 0 34 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            (click)="previousMonth()"
          >
            <g filter="url(#filter0_d_314_1105)">
              <rect x="4" y="2" width="26" height="22" rx="8" fill="white" shape-rendering="crispEdges" />
              <path
                d="M22 13.75C22.4142 13.75 22.75 13.4142 22.75 13C22.75 12.5858 22.4142 12.25 22 12.25V13.75ZM11.4697 12.4697C11.1768 12.7626 11.1768 13.2374 11.4697 13.5303L16.2426 18.3033C16.5355 18.5962 17.0104 18.5962 17.3033 18.3033C17.5962 18.0104 17.5962 17.5355 17.3033 17.2426L13.0607 13L17.3033 8.75736C17.5962 8.46447 17.5962 7.98959 17.3033 7.6967C17.0104 7.40381 16.5355 7.40381 16.2426 7.6967L11.4697 12.4697ZM22 12.25L12 12.25V13.75L22 13.75V12.25Z"
                fill="black"
              />
            </g>
            <defs>
              <filter
                id="filter0_d_314_1105"
                x="0"
                y="0"
                width="34"
                height="30"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="2" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_314_1105" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_314_1105" result="shape" />
              </filter>
            </defs>
          </svg>

          <svg
            width="34"
            height="30"
            viewBox="0 0 34 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            (click)="nextMonth()"
          >
            <g filter="url(#filter0_d_314_1107)">
              <rect x="4" y="2" width="26" height="22" rx="8" fill="white" shape-rendering="crispEdges" />
              <path
                d="M12 12.25C11.5858 12.25 11.25 12.5858 11.25 13C11.25 13.4142 11.5858 13.75 12 13.75V12.25ZM22.5303 13.5303C22.8232 13.2374 22.8232 12.7626 22.5303 12.4697L17.7574 7.6967C17.4645 7.40381 16.9896 7.40381 16.6967 7.6967C16.4038 7.98959 16.4038 8.46447 16.6967 8.75736L20.9393 13L16.6967 17.2426C16.4038 17.5355 16.4038 18.0104 16.6967 18.3033C16.9896 18.5962 17.4645 18.5962 17.7574 18.3033L22.5303 13.5303ZM12 13.75L22 13.75V12.25L12 12.25V13.75Z"
                fill="black"
              />
            </g>
            <defs>
              <filter
                id="filter0_d_314_1107"
                x="0"
                y="0"
                width="34"
                height="30"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="2" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_314_1107" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_314_1107" result="shape" />
              </filter>
            </defs>
          </svg>
        </div>
      </div>
      <div class="calendar">
        <div class="empty-day" *ngFor="let _ of emptyDays"></div>
        <div *ngFor="let day of days" class="day">
          <div class="circle">
            <calender-progress-bar [progress]="getProgressForDay(day) * 16.67" color="#E6A43D"></calender-progress-bar>
            <span class="day-number">{{ day }}</span>
          </div>
        </div>
      </div>
    </div>
  


// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/activity-achievement/components/calender-activity.component.ts.CalendarActivityComponent.html